import React from "react"
import { connect } from "react-redux"

import { setDragging } from "../../state/navbar"

import close_arrow from "../../images/icon/arrow-close-black.svg"
import open_arrow from "../../images/icon/arrow-open-black.svg"

const Dragger = ({ dragging, dispatch }) => {
  return (
    <div
      onClick={() => dispatch(setDragging(!dragging))}
      onKeyDown={() => dispatch(setDragging(!dragging))}
      role="button"
      tabIndex={0}
      className="drag-box"
    >
      <img src={dragging ? open_arrow : close_arrow} alt="grabby" width="18" />
    </div>
  )
}

export default connect(
  state => ({
    dragging: state.navbar.dragging,
  }),
  null
)(Dragger)
